/* eslint-disable @typescript-eslint/no-explicit-any */
import { trackingConfig } from './config';
import { loadScript } from './loadScript';

const inits = {
  facebook: () => {
    if (window.fbq) return;

    const n: any = (window.fbq = function (...args: any[]) {
      // eslint-disable-next-line prefer-spread
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    });

    if (!window._fbq) window._fbq = n;

    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];

    const script = document.createElement('script');
    script.async = !0;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';

    const insertTarget = document.getElementsByTagName('script')[0];

    insertTarget.parentNode?.insertBefore(script, insertTarget);

    window.fbq('init', trackingConfig.fbId);
  },

  taboola: async () => {
    window._tfa = window._tfa || [];
    window._tfa.push({ notify: 'event', name: 'page_view', id: trackingConfig.tabolaId });

    try {
      loadScript(
        `//cdn.taboola.com/libtrc/unip/${trackingConfig.tabolaId}/tfa.js`,
        'tb_tfa_script',
      );
    } catch {
      console.log('taboola failed...');
    }
  },

  microsoft: () => {
    window.uetq = window.uetq || [];

    const load = () => {
      const o = { ti: trackingConfig.microsoftUetId, enableAutoSpaTracking: true } as any;

      o.q = window.uetq;

      window.uetq = new (window as any).UET(o);

      window.uetq?.push('pageLoad');
    };

    const script = document.createElement('script') as HTMLScriptElement & {
      onreadystatechange?: null | (() => void);
    };

    script.src = '//bat.bing.com/bat.js';
    script.async = true;

    script.onload = script.onreadystatechange = function (this: any) {
      const s = this.readyState;

      if (!s || s === 'loaded' || s === 'complete') {
        load();

        script.onload = script.onreadystatechange = null;
      }
    };

    const insertTarget = document.getElementsByTagName('script')[0];

    insertTarget.parentNode!.insertBefore(script, insertTarget);
  },

  twitter: () => {
    if (window.twq) return;

    const s: any = (window.twq = (...args: any[]) => {
      // eslint-disable-next-line prefer-spread
      s.exe ? s.exe.apply(s, args) : s.queue.push(args);
    });

    s.version = '1.1';
    s.queue = [];

    window.twq?.('init', trackingConfig.twitterId);

    const script = document.createElement('script');
    script.async = true;
    script.src = '//static.ads-twitter.com/uwt.js';

    const insertTarget = document.getElementsByTagName('script')[0];

    insertTarget.parentNode!.insertBefore(script, insertTarget);
  },

  google: async () => {
    // Google gtag base
    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };

    try {
      await loadScript(`https://www.googletagmanager.com/gtag/js?id=${trackingConfig.gtagId}`);

      window.gtag('js', new Date());
      window.gtag('config', 'AW-1072735680');
      window.gtag('config', 'AW-404271196');
      window.gtag('config', 'AW-404272168');
      window.gtag('config', 'AW-629648936');
      window.gtag('config', trackingConfig.gtagId);
    } catch {
      console.log('gtag failed...');
    }
  },
};

export async function initTrackers() {
  await inits.google();

  inits.facebook();
  inits.microsoft();
  inits.twitter();

  // Taboola
  await inits.taboola();
}
